import { render, staticRenderFns } from "./info.vue?vue&type=template&id=06c09660&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=06c09660&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c09660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c09660')) {
      api.createRecord('06c09660', component.options)
    } else {
      api.reload('06c09660', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=06c09660&scoped=true", function () {
      api.rerender('06c09660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemModule/accountSetting/info.vue"
export default component.exports